<template>
  <div id="contenedor-proyecto-comentarios-chat" class="fill-height">
    <div
      class="d-flex flex-column fill-height rounded-lg"
      style="border: 1px solid #eee;">
      <v-toolbar
        dense
        flat
        class="mt-2">
        <v-toolbar-title>
          Comentarios
          <v-chip
            small
            :class="{'primary': mixListadoProyectoComentarios.length > 0 }">
            {{ mixListadoProyectoComentarios.length }}
          </v-chip>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span
          v-if="mixGetUltimoMensaje"
          class="caption text--secondary mr-2">
          último mensaje:
          <FechaHumano
            :fecha="mixGetUltimoMensaje.createdAt">
          </FechaHumano>
        </span>
        <v-btn
          icon
          class="mr-1"
          @click="mixCargarProyectoComentarios">
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="mx-3"></v-divider>
      <div
        id="proyecto-comentarios-contenedor"
        style="overflow: auto; max-height: 100%; display: flex; flex-direction: column-reverse;"
        class="fill-height py-3">
        <v-alert
          v-if="mixListadoProyectoComentarios.length <= 0"
          type="info"
          class="mx-3">
          No se han registrado comentarios.
        </v-alert>
        <template
          v-for="(comentario) in mixListadoProyectoComentarios">
          <template>
            <div
              class="d-flex align-top"
              style="position: relative; width: 100%;"
              :key="comentario.id">
              <v-hover
                v-slot="{ hover }">
                <div
                  class="d-flex py-2 px-3 mb-4"
                  :class="{'grey lighten-5': hover}"
                  style="width: 100%;">
                  <div class="mr-2">
                    <Avatar
                      tipo="nombre"
                      :nombre="comentario.usuarioRegistro.funcionario.nombre"
                      :img-url="`${$urlFileServer}/${comentario.usuarioRegistro.avatarPublicKey}`"
                      color="primary"
                      dark
                      :size="38">
                    </Avatar>
                  </div>
                  <div class="d-flex flex-column" style="width:100%;">
                    <div>
                      <span class="font-weight-bold">
                        {{ comentario.usuarioRegistro.funcionario.nombre }}
                      </span>
                      <span class="caption text--secondary ml-1">
                        {{ new Date(comentario.createdAt).toLocaleDateString() }},
                        {{ new Date(comentario.createdAt).toLocaleTimeString() }}
                      </span>
                    </div>
                    <div class="mt-1 px-2 py-1">
                      <v-alert
                        v-if="comentario.comentarioRespuesta"
                        color="info"
                        border="left"
                        colored-border
                        class="caption mx-2 py-1"
                        dense
                        elevation="1">
                        <div class="font-weight-bold">
                          {{ comentario.comentarioRespuesta.usuarioRegistro.funcionario.nombre }}
                        </div>
                        {{ comentario.comentarioRespuesta.comentario }}
                      </v-alert>
                      <span>
                        {{ comentario.comentario }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-show="hover"
                    style="position: absolute; right: 0; top:-10px;">
                    <div class="mr-2 pa-2">
                      <v-btn icon @click="citarComentario(comentario)">
                        <v-icon small>
                          mdi-format-quote-close
                        </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="$auth.user.id === comentario.idUsuarioRegistro"
                        icon
                        @click="borrarComentario(comentario)">
                        <v-icon small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-hover>
            </div>
          </template>
        </template>
      </div>
      <v-spacer></v-spacer>
      <v-divider></v-divider>
      <v-alert
        v-if="mixComentarioACitarTexto !== null"
        v-model="mostrarCitarComentario"
        color="info"
        border="left"
        colored-border
        class="caption mx-3 mt-2 py-1"
        dense
        dismissible
        elevation="1"
        transition="scale-transition">
        <div>
          Citar:
        </div>
        {{ mixComentarioACitarTexto }}
      </v-alert>
      <div class="px-2 my-2">
        <AgregarProyectoComentario
          :id-proyecto="idProyecto"
          :id-respuesta="idComentarioCitar"
          tipo="chat">
        </AgregarProyectoComentario>
      </div>
    </div>
    <v-dialog
    v-if="mostrarEliminarComentario"
    v-model="mostrarEliminarComentario"
    width="300">
      <EliminarProyectoComentario
        :id-proyecto="idProyecto"
        :proyectoComentarioEliminar="esteComentario"
        v-on:cerrar="cancelarBorrarComentario">
      </EliminarProyectoComentario>
    </v-dialog>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import FechaHumano from '@/components/FechaHumano.vue';
import mixProyectoComentarios from './mixProyectoComentarios';
import AgregarProyectoComentario from './Agregar.vue';
import EliminarProyectoComentario from './Eliminar.vue';

export default {
  name: 'ProyectoComentariosChat',
  mixins: [mixProyectoComentarios],
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  components: {
    AgregarProyectoComentario,
    EliminarProyectoComentario,
    FechaHumano,
    Avatar,
  },
  data() {
    return {
      idComentarioCitar: null,
      mostrarCitarComentario: false,
      mostrarEliminarComentario: false,
      esteComentario: null,
    };
  },
  methods: {
    cancelarBorrarComentario() {
      this.mostrarEliminarComentario = false;
      this.esteComentario = null;
    },
    borrarComentario(comentario) {
      this.esteComentario = comentario;
      this.mostrarEliminarComentario = true;
    },
    citarComentario(comentario) {
      this.idComentarioCitar = comentario.id;
      this.mixComentarioACitarTexto = comentario.comentario;
      this.mostrarCitarComentario = true;
    },
    cancelarCitarComentario() {
      this.idComentarioCitar = null;
      this.mixComentarioACitarTexto = null;
    },
  },
  watch: {
    mostrarCitarComentario: {
      handler(valor) {
        if (!valor) {
          this.cancelarCitarComentario();
        }
      },
    },
  },
};
</script>

<style lang="scss">

</style>
